var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnapshot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 0H.625A.624.624 0 000 .625v6.25c0 .346.28.625.625.625H8.75c.346 0 .625-.28.625-.625V.625A.624.624 0 008.75 0zm-.625 6.25H1.25v-5h6.875v5zM19.375 0H11.25a.624.624 0 00-.625.625v10c0 .346.28.625.625.625h8.125c.346 0 .625-.28.625-.625v-10A.624.624 0 0019.375 0zm-.625 10h-6.875V1.25h6.875V10zM8.75 8.75H.625A.624.624 0 000 9.375v10c0 .346.28.625.625.625H8.75c.346 0 .625-.28.625-.625v-10a.624.624 0 00-.625-.625zm-.625 10H1.25V10h6.875v8.75zM19.375 12.5H11.25a.624.624 0 00-.625.625v6.25c0 .346.28.625.625.625h8.125c.346 0 .625-.28.625-.625v-6.25a.624.624 0 00-.625-.625zm-.625 6.25h-6.875v-5h6.875v5z"
  }))));
}
export default SvgSnapshot;